import type { ProductProfileDto } from "../../types/ProductProfileDto";
import type { ProductProfileEntity } from "../../types/ProductProfileEntity";

export const ProductProfileDtoToEntity = ({ ...rest }: Readonly<ProductProfileDto>): ProductProfileEntity => {
    return { ...rest };
};
